import { FC } from "react";
import styled from "styled-components";
import { Icon, AllIconName, IconSize } from "../Icon";
import { BaseComponentProps } from "../types";
import { ButtonVariant } from "./types";

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0;
  padding: 5px;
  border-radius: var(--size-border-radius-small);
  border: none;
  background: transparent;
  white-space: nowrap;

  :disabled {
    cursor: not-allowed;
  }
  :not(:disabled) {
    &:hover {
      box-shadow: var(--elevation-2);
    }
    &:active {
      box-shadow: none;
      svg {
        --main-color: var(--color-secondary-800);
      }
    }
  }
`;

type ButtonProps = BaseComponentProps<
  "button",
  {
    iconName: AllIconName;
    iconSize?: IconSize;
    variant?: ButtonVariant;
  }
>;

export const PlainIconButton: FC<ButtonProps> = ({
  iconName,
  disabled = false,
  variant = ButtonVariant.DEFAULT,
  iconSize = "regular",
  ...buttonProps
}) => {
  return (
    <StyledButton
      {...buttonProps}
      disabled={variant === ButtonVariant.DISABLED || disabled}
    >
      <Icon
        iconSize={iconSize}
        iconName={iconName}
        plain
        variant={disabled ? ButtonVariant.DISABLED : variant}
      />
    </StyledButton>
  );
};
